module.exports = __webpack_public_path__ + "static/media/star_8.fc7653a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/star/star_8.jpg
// module id = 544
// module chunks = 0